import Cookies from "js-cookie";

export const REQUIRED_CLIENT_SIDE_COOKIES = [
    'apiBaseUrl',
];

const getCookieValue = (cookieName: string, defaultValue: string = ''): string => {
    const value = Cookies.get(cookieName);
    if (value == null) {
        return defaultValue;
    }
    return value;
}

export const getApiBaseUrl = (defaultValue: string = ''): string => {
    return getCookieValue('apiBaseUrl', defaultValue);
}

export const getReturnUrl = (defaultValue: string = ''): string => {
    return getCookieValue('returnUrl', defaultValue);
}

export const validateCookies = (cookies: string[]): boolean => {
    for (const cookie of cookies) {
        const cookieValue = getCookieValue(cookie);
        if (!cookieValue) {
            return false;
        }
    }
    return true;
}
